import { apiCaller } from "./metruyenvl_caller";

export const statAPI = {
    async getStat(targetType: "author" | "book" | "review" | "chapter" | "comment" | "user", targetID: string) {
        return apiCaller("/stat", "get", { query: { target_type: targetType, target_id: targetID } });
    },

    async getStats(targetType: "author" | "book" | "review" | "chapter" | "comment" | "user", targetIDs: string[]) {
        return apiCaller("/stat/all", "get", { query: { target_type: targetType, target_id: targetIDs.join(",") } });
    },
};
